module.exports = __webpack_public_path__ + "img/icon5-1(2).55545d74.png";